import { render, staticRenderFns } from "./TopQuestions.vue?vue&type=template&id=1794e003&scoped=true"
import script from "./TopQuestions.vue?vue&type=script&lang=js"
export * from "./TopQuestions.vue?vue&type=script&lang=js"
import style0 from "./TopQuestions.vue?vue&type=style&index=0&id=1794e003&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794e003",
  null
  
)

export default component.exports